const ProductCodes = {
  PAY_PER_LEAD: 'PAY_PER_LEAD',
  PAY_PER_CLICK: 'PAY_PER_CLICK',
  FLAT_FEE: 'FLAT_FEE',
  FLAT_FEE_FEED_CONNECT: 'FLAT_FEE_FEED_CONNECT',
  PAY_PER_LEASE: 'PAY_PER_LEASE',
  INTEGRATED_PAY_PER_LEASE: 'INTEGRATED_PAY_PER_LEASE',
  CONCIERGE_PAY_PER_LEASE: 'CONCIERGE_PAY_PER_LEASE',
  SINGLE_FAMILY: 'SINGLE_FAMILY',
  SINGLE_FAMILY_FLAT_FEE: 'SINGLE_FAMILY_FLAT_FEE',
  SINGLE_FAMILY_DAILY_LISTINGS: 'SINGLE_FAMILY_DAILY_LISTINGS',
  BASE_PACKAGE: 'BASE_PACKAGE',
  ENHANCED_PACKAGE: 'ENHANCED_PACKAGE',
  PREMIUM_PACKAGE: 'PREMIUM_PACKAGE',
  PREMIUM_PLUS_PACKAGE: 'PREMIUM_PLUS_PACKAGE',
  LEASE_UP: 'LEASE_UP',
  SIGNATURE_PACKAGE: 'SIGNATURE_PACKAGE',
  LISTING_SPOTLIGHT: 'LISTING_SPOTLIGHT',
};

const SalesforceProductCodes = {
  ...ProductCodes,
  BOOST: 'BOOST',
  BOOST_PRECISION_TARGETING: 'BOOST_PRECISION_TARGETING',
};

const ProductTypes = {
  [ProductCodes.PAY_PER_LEAD]: 'Zillow Rent Connect™',
  [ProductCodes.PAY_PER_CLICK]: 'Pay Per Click',
  [ProductCodes.FLAT_FEE]: 'Zillow Rent Connect™',
  [ProductCodes.FLAT_FEE_FEED_CONNECT]: 'Zillow Feed Connect™',
  [ProductCodes.PAY_PER_LEASE]: 'Pay Per Lease',
  [ProductCodes.INTEGRATED_PAY_PER_LEASE]: 'Pay Per Lease',
  [ProductCodes.CONCIERGE_PAY_PER_LEASE]: 'Pay Per Lease',
  [ProductCodes.SINGLE_FAMILY]: 'Pay Per Listing',
  [ProductCodes.SINGLE_FAMILY_FLAT_FEE]: 'Monthly Flat Fee',
  [ProductCodes.SINGLE_FAMILY_DAILY_LISTINGS]: 'Zillow Feed Connect™',
  [ProductCodes.BASE_PACKAGE]: 'Base Package',
  [ProductCodes.ENHANCED_PACKAGE]: 'Enhanced Package',
  [ProductCodes.PREMIUM_PACKAGE]: 'Premium Package',
  [ProductCodes.PREMIUM_PLUS_PACKAGE]: 'Premium Plus Package',
  [ProductCodes.LEASE_UP]: 'LeaseUp',
  [ProductCodes.SIGNATURE_PACKAGE]: 'Signature Package',
  [ProductCodes.LISTING_SPOTLIGHT]: 'Listing Spotlight',
};

export const SalesforceProductTypes = {
  ...ProductTypes,
  [SalesforceProductCodes.BOOST]: 'Boost',
  [SalesforceProductCodes.BOOST_PRECISION_TARGETING]: 'Boost PT',
};

const PackageTypes = new Set([
  ProductCodes.BASE_PACKAGE,
  ProductCodes.ENHANCED_PACKAGE,
  ProductCodes.PREMIUM_PACKAGE,
  ProductCodes.PREMIUM_PLUS_PACKAGE,
]);

const FlatFeeTypes = new Set([
  ...PackageTypes,
  ProductCodes.FLAT_FEE,
  ProductCodes.FLAT_FEE_FEED_CONNECT,
  ProductCodes.SINGLE_FAMILY_FLAT_FEE,
]);

const RocketshipTypes = new Set([ProductCodes.SINGLE_FAMILY_DAILY_LISTINGS, ProductCodes.FLAT_FEE_FEED_CONNECT]);

const SingleFamilyLegacyTypes = new Set([ProductCodes.SINGLE_FAMILY, ProductCodes.SINGLE_FAMILY_FLAT_FEE]);

const PackagePlatforms = {
  [ProductTypes.BASE_PACKAGE]: 'Z+T+HP',
  [ProductTypes.ENHANCED_PACKAGE]: 'Z+T+HP',
  [ProductTypes.PREMIUM_PACKAGE]: 'Z+T+HP+FB+IG',
  [ProductTypes.PREMIUM_PLUS_PACKAGE]: 'Z+T+HP+FB+IG',
};

export const ProductTypeNames = ProductTypes;

export const AdproductsConstants = {
  ProductTypes,
  PackagePlatforms,
  ProductCodes,
  PackageTypes,
  FlatFeeTypes,
  RocketshipTypes,
  SingleFamilyLegacyTypes,
};
